import { createMachine, type Sender } from 'xstate'
import { accountAuthMachine } from './machine-account'

type AuthenticationMachineEvent = {
  type: 'ENTRY_POINT_IS_WEB_URL'
}
export type FactorAuthentication = 'determiningUserType' | 'requiredAccount'
type AuthenticationTypestate = {
  value: FactorAuthentication
  context: {}
}

const authenticationMachine = createMachine<
  any,
  AuthenticationMachineEvent,
  AuthenticationTypestate
>(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QEMCuAXAFmAduglgMbIED2OAdBGOmAE4C2+OzUAqrPQCoCeADmADEAUQByXAEoBNAPoAFAPIBJcTKUBlGQHVhAIRlsJAGQDaABgC6iUH1Kx8ZHNZAAPRACYAnABYK7gBwAjO4ArAA0IDyIgQBsIRQhAL6JEWhYuATEjlQ09EwsOOycdLwCIuLS8sqqGjLqABIAghLCACIGxuZWSCC29o7ObghevgHB4ZEe3v4UAOxJKSBp2HhEJPjkObSMzKwc3PxCYpKyiipcaprCABpcwhKijUYdppbOfQ4bTj1DI35BoQiUQQ-ncfgWixwpGo8B6ywyawGPQ+SNAQwAtDEgYhMclUhgVpl1ptqNt8ntiqUwO87J9yINEN53NiEIEmQk8UsCQisl8KHQwABHVD4AUQRqEQikVB4Gn9L4MhAxMxgwKzQL+eYstlghb49KrXmbAXC0WQdSYZBigDC0OpyNpqNciGVqvVmomwPc0058MNxMoJpFYoU6ToADFkIR0KQ6HK6d80S6VRQ1RqtZMQYEOclEkA */
    id: 'authentication',
    initial: 'determiningUserType',
    states: {
      determiningUserType: {
        invoke: {
          src: 'determineUserType',
        },
        on: {
          ENTRY_POINT_IS_WEB_URL: { target: 'requiredAccount' },
        },
      },
      requiredAccount: {
        invoke: {
          id: 'accountAuthMachine',
          src: accountAuthMachine,
        },
      },
    },
    predictableActionArguments: true,
  },
  {
    services: {
      determineUserType:
        () => async (send: Sender<AuthenticationMachineEvent>) => {
          return send('ENTRY_POINT_IS_WEB_URL')
        },
    },
  },
)

export default authenticationMachine
